import { Component, Inject, OnInit } from '@angular/core';
import * as moment from 'moment';
import { ControlPointService } from 'src/app/services/control-point.service';
import { CommonConstant } from 'src/app/core/constant/common.constant';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-update-criteria',
    templateUrl: './update-criteria.component.html',
    styleUrls: ['./update-criteria.component.scss'],
    standalone: false // NOSONAR
})
export class UpdateCriteriaComponent implements OnInit {
  heading: any;
  gridApi: any;
  defaultColDef: any;
  columnDef: any;
  icons: any;
  context: any;
  displayRowData: any = [];
  gridOptions: any;
  domicile: any;
  domicileList: any;
  planName: any = '01TMK';
  plantList: any;
  lastUpdatedAt: any;
  lastUpdatedBy: any;
  errormsg: any = null;
  errorMessage: any = null;
  rowClassRules: any;
  mappedData: any;
  successMessage: any = null;
  plantValues: any;
  reponseArr: any = [];
  kpiCodeArray: any = [];



  constructor(
    public dialogRef: MatDialogRef<UpdateCriteriaComponent>,
    private readonly service: ControlPointService,
    @Inject(MAT_DIALOG_DATA) public dataStore: any,
     private readonly  ngxUiLoaderService : NgxUiLoaderService,
  ) {
    this.context = {
      componentParent: this,
    };
    this.rowClassRules = {
      'row-even': 'node.rowIndex % 2 == 0',    // NOSONAR
      'row-odd': 'node.rowIndex % 2 != 0',    // NOSONAR
    };
  }

  ngOnInit(): void {
    this.heading = this.dataStore.header;

    this.kpiCodeArray = [
      { kpiCode: 'suppliersClosed', rangeOrder: 'INCREASING' },
      { kpiCode: 'actualDroppedRoutes', rangeOrder: 'INCREASING' },
      { kpiCode: 'droppedRoutes', rangeOrder: 'INCREASING' },
      { kpiCode: 'droppedRoutesNotCovered', rangeOrder: 'INCREASING' },
      { kpiCode: 'namcExpedites', rangeOrder: 'INCREASING' },
      { kpiCode: 'recoveryExpedites', rangeOrder: 'INCREASING' },
      { kpiCode: 'expeditesNotCovered', rangeOrder: 'INCREASING' },
      { kpiCode: 'routesMissedUnload', rangeOrder: 'INCREASING' },
      { kpiCode: 'plannedMissedUnload', rangeOrder: 'INCREASING' },
      { kpiCode: 'parkingAvailable', rangeOrder: 'DECREASING' },
      { kpiCode: 'cntgntTrailersAvailable', rangeOrder: 'DECREASING' },
      { kpiCode: 'absenteeism', rangeOrder: 'INCREASING' },
      { kpiCode: 'misconnects', rangeOrder: 'INCREASING'},
      { kpiCode: 'blowout', rangeOrder: 'INCREASING' },
      { kpiCode: 'activeLateRoute', rangeOrder: 'INCREASING' },
      { kpiCode: 'activeShortage', rangeOrder: 'INCREASING' },
      { kpiCode: 'activePreemptive', rangeOrder: 'INCREASING' },
      { kpiCode: 'yardParkingCapacity', rangeOrder: 'INCREASING' },
      { kpiCode: 'parkingSpacesOccupied', rangeOrder: 'INCREASING' },
      { kpiCode: 'totalContingentTrailers', rangeOrder: 'INCREASING' },
      { kpiCode: 'contingentTrailersInUse', rangeOrder: 'INCREASING' },
      { kpiCode: 'dailyTotalBlowouts', rangeOrder: 'INCREASING' },
      { kpiCode: 'dailyTotalLateRoute', rangeOrder: 'INCREASING' },
      { kpiCode: 'dailyTotalShortage', rangeOrder: 'INCREASING' },
      { kpiCode: 'dailyTotalPreemptive', rangeOrder: 'INCREASING' }
    ]
    this.columnDef = [
      {
        headerName: 'KPI',
        autoHeight: true,
        field: 'kpiCode',
        cellClass: 'left_align',
        valueFormatter: function (params: any) {
          if (params.value == 'recoveryExpedites')    // NOSONAR
            {return 'Expedites Covered'}
          else if (params.value == 'cntgntTrailersAvailable')    // NOSONAR
            {return 'Contingent Trailers Available'}
          else if (params.value == 'namcExpedites')    // NOSONAR
           { return 'NAMC Expedites'}
          else
           { return (
              params.value.charAt(0).toUpperCase() +
              params.value.replace(/([A-Z]+)*([A-Z][a-z])/g, '$1 $2').slice(1)
            );}
        },
        minWidth: 220,
        maxWidth: 220,
      },
      {
        headerName: 'NORMAL RANGE',
        autoHeight: true,
        field: 'normal',
        cellStyle: { cursor: 'pointer', color: '#24B685' },
        valueFormatter: function (params: any) {
          if (
            params.data.kpiCode == 'cntgntTrailersAvailable' ||    // NOSONAR
            params.data.kpiCode == 'parkingAvailable'    // NOSONAR
          )
            {return '> ' + params.value;}
          return '≤ ' + params.value;
        },
        editable: true,
        //singleClickEdit: true,
      },
      {
        headerName: 'FAIR RANGE',
        autoHeight: true,
        field: 'fair',
        cellStyle: { cursor: 'pointer', color: '#4AC3FF' },
        valueFormatter: function (params: any) {
          if (
            params.data.kpiCode == 'cntgntTrailersAvailable' ||     // NOSONAR
            params.data.kpiCode == 'parkingAvailable'    // NOSONAR
          )
            {return '> ' + params.value;}
          return '≤ ' + params.value;
        },
        editable: true,
      },
      {
        headerName: 'CONCERN RANGE',
        field: 'concern',
        autoHeight: true,
        cellStyle: { cursor: 'pointer', color: '#CEAB38' },
        valueFormatter: function (params: any) {
          if (
            params.data.kpiCode == 'cntgntTrailersAvailable' ||    // NOSONAR
            params.data.kpiCode == 'parkingAvailable'    // NOSONAR
          )
           { return '> ' + params.value;}
          return '≤ ' + params.value;
        },
        editable: true,
      },
      {
        headerName: 'NG RANGE',
        field: 'bad',
        autoHeight: true,
        cellStyle: { color: '#EA5A5A' }, valueGetter: this.calculateColumn4Value,
      },
    ];
    this.plantList = this.dataStore.domicleList;
    this.onLPchange();
    this.icons = {
      sortUnSort: '<img src="assets/images/Icon awesome-sort.svg">',
    };
  }

  onLPchange() {
    this.successMessage = null;
    this.errorMessage = null;
    this.reponseArr = [];
    this.displayRowData = [];
    this.service.getUpdateCriteria(this.planName)?.subscribe({
      next: (res: any) => {
        this.reponseArr = res;
        if (this.reponseArr.length > 0) {
          this.lastUpdatedAt = this.dateFormatter(this.reponseArr[0].updatedDate);
          this.lastUpdatedBy = this.reponseArr[0].updatedBy;
        }

        for (let i = 0; i < this.kpiCodeArray.length; i++) {
          let id = false;
          let data = []
          if (this.reponseArr.length > 0) {
            for (let j = 0; j < this.reponseArr.length; j++) {
              if (this.kpiCodeArray[i].kpiCode == this.reponseArr[j].kpiCode) {    // NOSONAR
                id = true
                data = this.reponseArr[j];
              }
            }
          }
          if (id) {

            this.displayRowData.push(data);
          } else {

            this.displayRowData.push(
              {
                bad: '',
                concern: '',
                fair: '',
                kpiCode: this.kpiCodeArray[i].kpiCode,
                logisticsPoint: "",
                normal: '',
                rangeOrder: this.kpiCodeArray[i].rangeOrder,
                thresholdId: '',
                updatedBy: '',
                updatedDate: '',
              }
            )
          }

        }

        this.displayRowData = [...this.displayRowData]

      },
      error: (error) => {
        console.info(error);
        this.errorMessage = "Error";
      },
    });
  }

  updateValidation() {
    let returnVal = true;
    if (!this.requiedValidation() || !this.orderValidation()) {
      returnVal = false;
    } 

    return returnVal;
  }

  orderValidation() {
    let isValid = true;
    for (let i = 0; i < this.mappedData.length; i++) {
      const currentRow = this.mappedData[i];
      if (
        currentRow.kpiCode == 'parkingAvailable' ||     // NOSONAR
        currentRow.kpiCode == 'cntgntTrailersAvailable'     // NOSONAR
      ) {
        if (
          parseInt(currentRow.normal) <= parseInt(currentRow.fair) ||
          parseInt(currentRow.fair) <= parseInt(currentRow.concern)
        ) {
          this.errorMessage =
            currentRow.kpiCode.charAt(0).toUpperCase() +
            currentRow.kpiCode
              .replace(/([A-Z]+)*([A-Z][a-z])/g, '$1 $2')
              .slice(1) +
            ' should be in decreasing order.';

          isValid = false;
          break;
        }
      } else if (
        parseInt(currentRow.normal) >= parseInt(currentRow.fair) ||
        parseInt(currentRow.fair) >= parseInt(currentRow.concern)
      ) {
        this.errorMessage =
          currentRow.kpiCode.charAt(0).toUpperCase() +
          currentRow.kpiCode
            .replace(/([A-Z]+)*([A-Z][a-z])/g, '$1 $2')
            .slice(1) +
          ' should be in increasing order.';

        isValid = false;
        break;
      }
    }
    return isValid;
  }

  requiedValidation() {
    let value = true;
    for (const element of this.mappedData) {
      if (element.normal == '' || element.fair == '' || element.concern == '') {    // NOSONAR
        this.errorMessage = "Required all the values";
        value = false;
        break;
      }
    }
    return value;
  }

  update() {
    this.successMessage = null;
    this.errorMessage = null;
    const isValid = true;
    this.mappedData = this.displayRowData.map((item) => {
      return {
        logisticsPoint: item.logisticsPoint !=   '' ? item.logisticsPoint : this.planName,   // NOSONAR
        kpiCode: item.kpiCode,
        normal: parseInt(item.normal),
        fair: parseInt(item.fair),
        concern: parseInt(item.concern),
        rangeOrder: item.rangeOrder,
        bad: item.bad !=   '' ? parseInt(item.bad) : parseInt(item.concern),   // NOSONAR
      };
    });
    if (!this.updateValidation()) {
      return
    }
    this.sendRequest();
  }

  calculateColumn4Value(params: any): any {
    if (
      params.data.kpiCode == 'cntgntTrailersAvailable' ||     // NOSONAR
      params.data.kpiCode == 'parkingAvailable'                         // NOSONAR
    ) {
      return '≤ ' + params.data.concern;
    }
    return '> ' + params.data.concern;
  }

  sendRequest() {
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.successMessage = null;
    this.errorMessage = null;
    this.service.putUpdateCriteria(this.mappedData).subscribe({
      next: (res: any) => {
        this.dialogRef.close({ event: 'success', response: res });
      },
      error: (error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        console.info(error);
        this.errorMessage = "Error";
      },
    });
  }

  close(): void {
    this.dialogRef.close({ event: 'CloseEvent' });
  }

  sizeToFit() {
    this.gridApi?.sizeColumnsToFit();
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }
  dateFormatter(res) {
    return res ? moment.utc(res).format('MM/DD/YYYY HH:mm:ss') : null;
  }

  closeNotification() {
    this.successMessage = null;
    this.errorMessage = null;
  }
}
